import {AiFillFacebook, AiOutlineInstagram, AiFillLinkedin} from 'react-icons/ai'
import {AiOutlineTwitter} from 'react-icons/ai'
import {AiOutlineDribbble} from 'react-icons/ai'
import {AiOutlineLinkedin} from 'react-icons/ai'
// import {AiOutlineFacebook} from 'react-icons/ai'
import {AiFillGithub} from 'react-icons/ai'

export const links = [
    {id: 1, link: '#', title: 'Home'},
    {id: 2, link: '#about', title: 'About'},
    {id: 3, link: '#services', title: 'Services'},
    {id: 4, link: '#portfolio', title: 'Portfolio'},
    {id: 5, link: '#contact', title: 'Contact'}
]


export const socials = [
    {id: 3, link: 'https://www.linkedin.com/company/int-elligence-tech/', icon: <AiFillLinkedin/>},
    {id: 1, link: 'https://www.instagram.com/intelligence.co.uk/', icon: <AiOutlineInstagram/>},
    {id: 2, link: 'https://twitter.com/_int_elligence', icon: <AiOutlineTwitter/>},
    
    {id: 4, link: 'https://www.facebook.com/int.elligence523/', icon: <AiFillFacebook/>}
]